import * as React from 'react'
import { observer } from 'mobx-react'
import { ConfirmViewModel } from '../ConfirmDialog/ConfirmViewModel'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from '../ModalSheet'
import { isChildrenEmpty } from '../../utils/react-util'
import Button from '../Button'

interface ConfirmSheetProps {
  children?: React.ReactNode
  title?: React.ReactNode
  description?: React.ReactNode
  yes?: string
  no?: string
  danger?: boolean
  disableCloseOnEsc?: boolean
  disableCloseOnOutsideClick?: boolean
  state: ConfirmViewModel
  ['data-test']?: {
    confirm: string
    decline: string
    closeButton?: string
  }
}

export default observer(function ConfirmSheet({
  children,
  title,
  yes = 'Confirm',
  no = 'Cancel',
  danger,
  disableCloseOnOutsideClick,
  disableCloseOnEsc,
  state,
  'data-test': dataTest,
}: ConfirmSheetProps) {
  const hasTitle = !isChildrenEmpty(title)
  return (
    <ModalSheet
      disableCloseOnOutsideClick={disableCloseOnOutsideClick}
      disableCloseOnEsc={disableCloseOnEsc}
      showing={state.showing}
      onRequestClose={state.decline}
    >
      <ModalSheetHeader
        withCloseButton
        closeButtonDataTest={dataTest?.closeButton}
        bordered={hasTitle}
      >
        {hasTitle && <ModalSheetTitle>{title}</ModalSheetTitle>}
      </ModalSheetHeader>
      <ModalSheetContent>{children}</ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button dataTest={dataTest?.decline} onClick={state.decline}>
            {no}
          </Button>
          <Button
            dataTest={dataTest?.confirm}
            type={danger ? 'danger' : 'primary'}
            onClick={state.confirm}
          >
            {yes}
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
